/**
 * RES-42 — Errores del backend de inventario traducidos por `code`.
 *
 * El backend responde `{ error, code, message, field }` con `message` en castellano. Para que el
 * admin hable el idioma del usuario se muestra la traducción del `code` (`inventory.errors.*`);
 * el `message` crudo queda solo para la consola.
 */

/** Códigos con traducción en `inventory.errors.*` (inventario y validación de recetas/vínculos de menu). */
export const INVENTORY_ERROR_CODES = [
  'FORBIDDEN',
  'NOT_A_MEMBER',
  'ORG_SCOPE_REQUIRED',
  'CATALOG_LOCKED',
  'RECIPES_LOCKED',
  'ORG_RECIPE_LOCKED',
  'POLICY_LOCKED',
  'RESTAURANT_REQUIRED',
  'INVALID_RESTAURANT',
  'INVALID_TARGET_RESTAURANT',
  'ITEM_NOT_FOUND',
  'INVALID_ITEMS',
  'INVALID_UNIT',
  'INVALID_KIND',
  'INVALID_NUMBER',
  'INVALID_TYPE',
  'REQUIRED',
  'TOO_LONG',
  'STOCK_READ_ONLY',
  'STOCK_NOT_TRACKED',
  'INSUFFICIENT_STOCK',
  'INVALID_MOVEMENT_TYPE',
  'WASTE_REASON_REQUIRED',
  'INVALID_REF',
  'INVALID_DATE',
  'UNIT_MISMATCH',
  'RECIPE_ITEM_NOT_FOUND',
  'RECIPE_LINE_INVALID',
  'RECIPE_UNIT_MISMATCH',
  'RECIPE_CRITICAL_INVALID',
  // Épica D (cadenas, RES-43…47)
  'INVALID_STATUS',
  'SAME_RESTAURANT',
  'DUPLICATE_ITEM',
  'TOO_MANY',
  'TRANSFER_SCOPE',
  'STOCK_CHANGED',
  'RECIPE_REQUIRED',
  'VERSION_CONFLICT',
  'ORG_RECIPE_NOT_FOUND',
  'INVALID_RECIPE_SOURCE',
  'ALREADY_IN_CATALOG',
  'DUPLICATE_SUGGESTION',
  'ALREADY_REVIEWED',
  'INVALID_DECISION',
  'INVALID_RANGE',
  'RANGE_TOO_LONG',
  'INVALID_GROUP_BY',
  'UNKNOWN_REPORT',
];

/**
 * Código de error de una respuesta de la API (o `FORBIDDEN` para un 403 sin código conocido).
 * @param {*} error - Error de axios
 * @returns {string|null} Código traducible o `null`
 */
export function inventoryErrorCode(error) {
  const data = (error && error.response && error.response.data) || {};
  if (INVENTORY_ERROR_CODES.includes(data.code)) return data.code;
  if (error && error.response && error.response.status === 403) return 'FORBIDDEN';
  return null;
}

/**
 * Mensaje para el usuario: la traducción del código o, si no hay, la de `fallbackKey`.
 * @param {Function} t - `t` de i18next
 * @param {*} error - Error de axios
 * @param {string} fallbackKey - Clave genérica de la pantalla
 * @returns {string} Mensaje traducido
 */
export function inventoryErrorMessage(t, error, fallbackKey) {
  const code = inventoryErrorCode(error);
  return code ? t(`inventory.errors.${code}`) : t(fallbackKey);
}
